import { CREATE_CHECKOUT_SESSION } from "./Mutations";
import {
  GET_CUSTOMER_BILLING_PORTAL_LINK,
  GET_PAYMENT_INFO,
  GET_SCHOOL_SUBSCRIPTION_TYPES,
  GET_USER_SUBSCRIPTION_INFO,
  GET_POSSIBLE_USER_SUBSCRIPTION_PLANS,
} from "./Queries";

export class SubscriptionsClient {
  constructor(client) {
    this.client = client;
  }

  async createCheckoutSession({ successUrl, cancelUrl, stripePriceId }) {
    const res = await this.client.mutate({
      mutation: CREATE_CHECKOUT_SESSION,
      variables: { successUrl, cancelUrl, stripePriceId },
    });

    return res.data.createCheckoutSession;
  }

  async getCustomerBillingPortalLink() {
    const res = await this.client.query({
      query: GET_CUSTOMER_BILLING_PORTAL_LINK,
    });
    return res.data.billingPortalLink;
  }

  async getUserSubscriptionInfo() {
    const res = await this.client.query({
      query: GET_USER_SUBSCRIPTION_INFO,
    });
    return res.data.userSubscriptionInfo;
  }

  async getPaymentInfo() {
    const res = await this.client.query({
      query: GET_PAYMENT_INFO,
    });

    return res.data.paymentInfo;
  }
  async getSchoolSubscriptionTypes() {
    const res = await this.client.query({
      query: GET_SCHOOL_SUBSCRIPTION_TYPES,
    });

    return res.data.schoolSubscriptionTypes;
  }
  async getPossibleUserSubscriptionPlans() {
    const res = await this.client.query({
      query: GET_POSSIBLE_USER_SUBSCRIPTION_PLANS,
    });

    return res.data.subscriptionPlans;
  }
}
